"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.promoVideoComponent = exports.SpotGroupRenderPreview = void 0;
const app_1 = require("app");
const PreviewImage_1 = require("./PreviewImage");
class SpotGroupRenderPreview extends app_1.Component {
    constructor() {
        super(...arguments);
        this.selector = '.spot-cascade .img-empty-wrapper';
    }
    OnInit() {
        const emptyImgCTAs = [];
        this.el.forEach(el => el.querySelectorAll('.play-video-button').forEach(item => emptyImgCTAs.push(item)));
        const emptyImgCTA = emptyImgCTAs[0];
        const playButtonAriaLabel = emptyImgCTA.getAttribute('aria-label');
        const popupAriaLabel = emptyImgCTA.getAttribute('data-popup-aria-label');
        const closeButtonAriaLabel = emptyImgCTA.getAttribute('data-close-button-aria-label');
        const videoUrls = $.makeArray(emptyImgCTAs.map(el => {
            return el.getAttribute('data-url');
        }));
        videoUrls.forEach((videoUrl, index) => {
            if (app_1.VideoService.checkIfYoutube(videoUrl)) {
                (0, PreviewImage_1.RenderPreviewImage)(videoUrl, this.el[index], playButtonAriaLabel, popupAriaLabel, closeButtonAriaLabel);
            }
            else {
                this.el.forEach(el => el
                    .querySelectorAll('.img-empty')
                    .forEach(item => item.classList.toggle('img-empty img-video-empty')));
            }
        });
    }
}
exports.SpotGroupRenderPreview = SpotGroupRenderPreview;
exports.promoVideoComponent = new SpotGroupRenderPreview();
